import React, { useEffect, useRef, useState } from 'react';
import { resumenCola } from 'lib/offlineQueue';

// Salir de la sesión PIN. El teléfono se comparte: antes de salir se avisa de
// lo que se pierde o queda pendiente.
//   - una inspección a medias: se descarta (el borrador no se queda para otro);
//   - inspecciones guardadas sin enviar (cola): sin sesión no se envían. Se
//     envían solas cuando alguien vuelva a entrar con PIN en este teléfono, y
//     la base solo las acepta hasta la medianoche del día siguiente al de su
//     sesión; después quedan rechazadas.

export const contarPendientesCola = async () => {
  try {
    const r = await resumenCola();
    return Number(r?.total) || 0;
  } catch (e) {
    return 0;
  }
};

// pedir({ hayAvance }) abre la confirmación si hace falta; si no, sale.
export function useSalidaPin({ salir, contarPendientes = contarPendientesCola }) {
  const [confirmar, setConfirmar] = useState(null); // { hayAvance, pendientes }
  const vivoRef = useRef(true);
  useEffect(() => () => { vivoRef.current = false; }, []);

  const pedir = async ({ hayAvance = false } = {}) => {
    const pendientes = await contarPendientes();
    if (!vivoRef.current) return;
    if (!hayAvance && !pendientes) {
      salir();
      return;
    }
    setConfirmar({ hayAvance, pendientes });
    try {
      window.scrollTo(0, 0); // la confirmación aparece arriba del paso
    } catch (e) { /* entorno sin scroll */ }
  };
  return { confirmar, pedir, cancelar: () => setConfirmar(null) };
}

export function ConfirmarSalida({ hayAvance, pendientes, onCancelar, onSalir }) {
  const cancelarRef = useRef(null);
  useEffect(() => { cancelarRef.current?.focus(); }, []);
  return (
    <div
      role="alertdialog"
      aria-label="Confirmar salida"
      className="mb-4 rounded-2xl border-2 border-foreground/30 bg-card p-4 shadow-card"
    >
      {hayAvance ? (
        <p className="text-base font-semibold text-foreground">
          Hay una inspección sin terminar. ¿Salir y descartarla?
        </p>
      ) : null}
      {pendientes > 0 ? (
        <div data-aviso="cola" className={hayAvance ? 'mt-3' : ''}>
          <p className="text-base font-semibold text-foreground">
            {pendientes === 1
              ? 'Hay 1 inspección guardada en este teléfono que todavía no se envió.'
              : `Hay ${pendientes} inspecciones guardadas en este teléfono que todavía no se enviaron.`}
          </p>
          <p className="mt-1 text-base text-foreground">
            Al salir no se envían. Se envían solas cuando alguien vuelva a entrar con PIN en este teléfono, antes
            de la medianoche siguiente; después de esa hora la base ya no las acepta.
          </p>
        </div>
      ) : null}
      <div className="mt-3 flex gap-3">
        <button
          ref={cancelarRef}
          type="button"
          onClick={onCancelar}
          className="min-h-[48px] flex-1 rounded-xl border-2 border-border bg-white px-3 text-base font-semibold text-foreground"
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={onSalir}
          className="min-h-[48px] flex-1 rounded-xl bg-foreground px-3 text-base font-semibold text-white"
        >
          {hayAvance ? 'Salir y descartar' : 'Salir de todos modos'}
        </button>
      </div>
    </div>
  );
}
